import { Component, ChangeDetectionStrategy } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	selector: "deposit-success",
	templateUrl: "./deposit-success.component.html",
	styleUrls: ["../deposit-common-end-screen/deposit-common-end-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositSuccessComponent extends CustomModal {
	public constructor() {
		super();
	}
}
